import React from 'react';

import MetaTags from '../shared/MetaTags';
import Layout from './Layout';

const OG_IMAGE_PATH = '/global/og_images/directory_social_cover.png';
const DESCRIPTION =
  'Make connections worth your time without all the noise. Search, find and engage with others who are serious about tech and business.';

const SubscriberDirectory = () => {
  return (
    <>
      <MetaTags
        title="The Information Subscriber Directory"
        description={DESCRIPTION}
        ogImagePath={OG_IMAGE_PATH}
        ogSiteName="The Information"
      />
      <Layout />
    </>
  );
};

export default SubscriberDirectory;
